import { cateringOrderClient } from '@/services/clients'

export default {
  getEventTypes() {
    return cateringOrderClient.get('/enum/eventtypes', undefined, {
      callerHandlesCriticalError: true,
    })
  },
}
